import {Protocol, ProtocolVersion} from 'notebook/ELNConstants';
import DocumentEvaluationUpdater from 'notebook/mediocre/DocumentEvaluationUpdater';
import {DocumentMapper, DocumentTraverser} from 'notebook/mediocre/DocumentTraversal';

export default class ProtocolUpdater extends DocumentEvaluationUpdater<Protocol, ProtocolVersion> {
  getDoc(item: Protocol): ProtocolVersion {
    return item;
  }

  traverse(evalTraverser: DocumentTraverser, newDoc: ProtocolVersion, oldDoc: ProtocolVersion | null): void {
    evalTraverser.walkProtocolVersion(newDoc, oldDoc);
  }

  mapDoc(mapper: DocumentMapper, doc: ProtocolVersion): ProtocolVersion {
    return mapper.mapProtocolVersion(doc, null);
  }

  updatedRoot(root: Protocol, doc: ProtocolVersion): Protocol {
    return {...root, ...doc};
  }
}
